module.exports = __webpack_public_path__ + "static/media/invite2.51af4f36.svg";